import React from 'react';
import { injectGlobal } from 'styled-components';

import AllRoundGothicDemi from '../../fonts/All_Round_Gothic_Demi.woff';
import RobotoRegular from '../../fonts/Roboto-Regular.ttf';
import RobotoBlack from '../../fonts/Roboto-Black.ttf';
import RobotoBold from '../../fonts/Roboto-Bold.ttf';
import RobotoLight from '../../fonts/Roboto-Light.ttf';
import RobotoMedium from '../../fonts/Roboto-Medium.ttf';
import RobotoThin from '../../fonts/Roboto-Thin.ttf';

import RobotoCondensed from '../../fonts/RobotoCondensed-Regular.ttf';
import RobotoCondensedItalic from '../../fonts/RobotoCondensed-Italic.ttf';
import RobotoCondensedLight from '../../fonts/RobotoCondensed-Light.ttf';
import RobotoCondensedLightItalic from '../../fonts/RobotoCondensed-LightItalic.ttf';
import RobotoCondensedBold from '../../fonts/RobotoCondensed-Bold.ttf';

import IconsFontTTF from '../../images/icons/icon-font/icomoon.ttf';
import IconsFontEOT from '../../images/icons/icon-font/icomoon.eot';
import IconsFontWOFF from '../../images/icons/icon-font/icomoon.woff';
import IconsFontSVG from '../../images/icons/icon-font/icomoon.svg';
//import RobotoCondensedBoldItalic from '../../fonts/RobotoCondensed-BoldItalic.ttf';

const DKGlobalInject = (props) => {
    injectGlobal`
      
      @font-face {
        font-family: 'AllRoundGothicDemi';
        src: url(${AllRoundGothicDemi});      
      }

      @font-face {
          font-family: 'Roboto';
          src: url(${RobotoRegular});
      }

      @font-face {
          font-family: 'Roboto';
          src: url(${RobotoThin});
          font-weight: 100;
      }

      @font-face {
          font-family: 'Roboto';
          src: url(${RobotoLight});
          font-weight: 300;
      }

      @font-face {
          font-family: 'Roboto';
          src: url(${RobotoRegular});
          font-weight: 400;
      }

      @font-face {
          font-family: 'Roboto';
          src: url(${RobotoMedium});
          font-weight: 500;
      }

      @font-face {
          font-family: 'Roboto';
          src: url(${RobotoBold});
          font-weight: 700;
      }

      @font-face {
          font-family: 'Roboto';
          src: url(${RobotoMedium});
          font-weight: bold;
      }

      @font-face {
          font-family: 'Roboto';
          src: url(${RobotoBlack});
          font-weight: 900;
      }

      @font-face {
            font-family: 'Roboto Condensed';
            src: url(${RobotoCondensedLight});
            font-weight: normal;
            font-style: normal;
      }

        @font-face {
            font-family: 'Roboto Condensed';
            src: url(${RobotoCondensed});
            font-weight: bold;
            font-style: normal;
        }
        
        @font-face {
            font-family: 'Roboto Condensed';
            src: url(${RobotoCondensed});
            font-weight: 800;
            font-style: normal;
        }
        
        @font-face {
            font-family: 'Roboto Condensed';
            src: url(${RobotoCondensedBold});
            font-weight: 900;
            font-style: normal;
        }
        
        @font-face {
            font-family: 'Roboto Condensed';
            src: url(${RobotoCondensedLightItalic});
            font-weight: normal;
            font-style: italic;
        }
        
        @font-face {
            font-family: 'Roboto Condensed';
            src: url(${RobotoCondensedItalic});
            font-weight: bold;
            font-style: italic;
        }
        
        @font-face {
             font-family: 'Icon Fonts';
             src: url(${IconsFontTTF});
             src: url(${IconsFontEOT}) format('embedded-opentype'),
             url(${IconsFontTTF}) format('truetype'),
             url(${IconsFontWOFF}) format('woff'),
             url(${IconsFontSVG}) format('svg');
             font-weight: normal;
             font-style: normal;
        }


      html {
         -webkit-overflow-scrolling: auto;
         height: 100%;
      }

      .noscroll {
          overflow: hidden;
        }

      * {
        font-family: 'Roboto Condensed', sans-serif;
        outline: none !important;
        -webkit-tap-highlight-color: rgba(255, 255, 255, 0) !important;
      }

      *::focus {
            outline: none;
            -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
      }

      *::active {
            outline: none;
            -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
      }

      *::target {
            outline: none;
            -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
      }

      body {
        margin: 0px;
        padding: 0px;
        height: 100%;
        font-family: 'Roboto Condensed', sans-serif;
        position: relative;
      }
      
      #root {
        height: 100%;
      }
      
      .notification-container .notification {
          box-shadow: 0 0 12px rgba(0,0,0,0.2);
      }

      .carousel img {
          width: inherit !important;
      }
      
      [class^="icon-"], [class*=" icon-"] {
          /* use !important to prevent issues with browser extensions that change fonts */
          font-family: 'Icon Fonts', sans-serif !important;
          speak: none;
          font-style: normal;
          font-weight: normal;
          font-variant: normal;
          text-transform: none;
          line-height: 1;
        
          /* Better Font Rendering =========== */
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }
    `;

    return <div className="full-height">{props.children}</div>;
};

export default DKGlobalInject;
